/*
 * @Author: Merlin
 * @Date: 2024-01-17 14:36:14
 * @LastEditors: Merlin
 * @LastEditTime: 2024-01-17 14:37:19
 * @Description: 
 */
import step01 from '../img/rule01.png';
import step02 from '../img/rule02.png';

export const aHiloRule = [{
    content1: 'hilo.ruleDesc01',
    constent2: '',
    img: step01,
},{
    content1: 'hilo.ruleDesc02',
    constent2: '',
    img: step02,
},];


